// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-home-index-js": () => import("/opt/build/repo/src/templates/Home/index.js" /* webpackChunkName: "component---src-templates-home-index-js" */),
  "component---src-templates-page-index-js": () => import("/opt/build/repo/src/templates/Page/index.js" /* webpackChunkName: "component---src-templates-page-index-js" */),
  "component---src-templates-website-index-js": () => import("/opt/build/repo/src/templates/Website/index.js" /* webpackChunkName: "component---src-templates-website-index-js" */)
}

